import React, { Fragment } from 'react';
import withMobileDialog from '@material-ui/core/withMobileDialog';

import FlatButton from 'material-ui/FlatButton';
import { List } from 'material-ui/List';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import Dialog from '@material-ui/core/Dialog';

import { AccentColor } from 'helpers/AccentColorHelper';
import { toFriendlyTimeString, formatPhone } from 'helpers/Formatter';
import { getTranslatedString } from 'helpers/i18n';

import { localize } from 'react-localize-redux';

const style = {
  no_padding: {
    padding: 0,
  },
  propertyFAQ: {
    padding: '5px 15px',
    background: '#efefef',
    borderRadius: '8px',
    margin: '20px 15px 15px',
    whiteSpace: 'pre-wrap',
  },
};

let PropertyFAQInfo = class extends React.Component {
  render() {
    return (
      <Dialog
        fullScreen={this.props.fullScreen}
        open={this.props.isOpen}
        onClose={this.props.toggleDialog}
        aria-labelledby="view-documents"
        classes={{
          paper: 'form-dialog',
        }}
      >
        <DialogContent>{this.renderDialogContent()}</DialogContent>
        <DialogActions style={{ display: 'block' }}>{this.renderDialogActions()}</DialogActions>
      </Dialog>
    );
  }

  renderDialogContent = () => {
    return (
      <List style={style.no_padding}>
        <div>
          {this._renderContactDetails()}
          {this._renderPropertyFAQ()}
        </div>
      </List>
    );
  };

  _renderPropertyFAQ = () => {
    const { propertyFAQ } = this.props;
    if (!propertyFAQ) return;

    return (
      <div className="row">
        <h3 style={{ margin: '8px 15px 16px 15px' }}>
          {getTranslatedString('portal.frequentlyAskedQuestions')}
        </h3>
        <div style={style.propertyFAQ}>
          <p>{propertyFAQ}</p>
        </div>
      </div>
    );
  };

  _renderContactDetails = () => {
    const { contactDetails } = this.props;
    if (!contactDetails) return;
    if (contactDetails.length === 0) return;

    return (
      <div className="row">
        <h3 style={{ margin: '8px 15px 16px 15px' }}>
          {getTranslatedString('portal.importantContactInformation')}
        </h3>
        {contactDetails.map(contactCard => (
          <div className="col-sm-6">
            <h4 style={{ textTransform: 'capitalize' }}>
              {getTranslatedString(`tenantPortal.propertyFaqInfo.${contactCard.contact_card_type}`)}
            </h4>
            {contactCard.email ? <p>{contactCard.email}</p> : null}
            <p>
              {formatPhone(contactCard.phone_number)}
              {contactCard.phone_number_extension
                ? ` ext. ${contactCard.phone_number_extension}`
                : null}
            </p>
            {contactCard.contact_card_type === 'office' && (
              <p>
                {toFriendlyTimeString(contactCard.business_hours_start, {
                  language: this.props.currentLanugage,
                })}{' '}
                -{' '}
                {toFriendlyTimeString(contactCard.business_hours_end, {
                  language: this.props.currentLanugage,
                })}
              </p>
            )}
          </div>
        ))}
      </div>
    );
  };

  renderDialogActions = () => (
    <Fragment>
      <FlatButton
        onClick={this.props.toggleDialog}
        id="close-button"
        style={{ color: AccentColor(), textTransform: 'uppercase' }}
      >
        {this.props.translate('close')}
      </FlatButton>
    </Fragment>
  );
};

export default localize()(withMobileDialog()(PropertyFAQInfo));
